import { render, staticRenderFns } from "./FormularioResultadosComponent.vue?vue&type=template&id=45c1861b&"
import script from "./FormularioResultadosComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioResultadosComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioResultadosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports